module.exports = __webpack_public_path__ + "media/images/v3/s_4-fd4e177b53259726657b6aa4f3fc3122.png";